

<template>
	<div class="container mx-auto my-20">
		<div class="w-full lg:w-8/12 2xl:w-6/12 mx-auto">
		<img :src="require('./assets/ugent-logo-'+this.$store.state.language+'.svg')" class="c-logo" />
			<h2>{{copy.title}}</h2>
			<Question />
		</div>
	</div>
</template>

<script>
	import Question from "./components/Question.vue";
	export default {
		components: {
			Question,
		},
		computed: {
			copy: function () {
				return this.$store.state.copy[0][this.$store.state.language];
			},
		},
	};
</script>

<style lang="scss">
	/*
	** COLOURS
	*/

	$primary: #1e64c8;
	$secondary: #e9f0fa;

	$white: #ffffff;
	$grey: #f0f0ec;
	$dark: #0a0a0a;

	body {
		font-size: 16px;
		line-height: 1.8;
		margin: 3rem 0;

		@media print {
			margin-top: 1rem;
			margin-bottom: 0;
			font-size: 14px;
		}

		h2 {
			font-size: 2rem;
			font-weight: bold;
			margin-bottom: 1.5rem;
			color: $primary;
			@media print {
				margin-bottom: 0;
				font-size: 1.6rem;
				margin-bottom: 0.5rem;
			}
		}

		h3 {
			font-size: 1.3rem;
			font-weight: bold;
			@media print {
				font-size: 1.2rem;
			}
		}

		h4 {
			font-size: 1rem;
			font-weight: bold;
			margin-bottom: 1.5rem;

			ul {
				font-weight: normal;
			}
		}

		a {
			color: $primary;
			text-decoration: underline;
			&:hover {
				text-decoration: none;
			}
		}

		.button {
			padding: 0.5rem 1.2rem;
			font-weight: bold;
			transition: all 0.3s ease-out;

			@media print {
				display: none;
			}

			&--primary {
				background-color: $primary;
				color: $white;

				&:hover {
					background-color: lighten($primary, 5%);
				}
			}

			&--ghost {
				border: 1px solid $secondary;
				&:hover {
					border-color: $primary;
				}
			}
			&--underline {
				text-decoration: underline;
				font-weight: normal;
				color: $primary;
				svg {
					width: 18px;
					height: 18px;
					fill: $primary;
					margin-right: 0.4rem;
				}
				&:hover {
					text-decoration: none;
				}
			}
			&--small {
				font-size: 0.8rem;
				color: $dark;
			}
		}

		.icon {
			width: 18px;
			height: 18px;
			fill: $primary;
		}

		.c-logo{
			width: 100px;
			height: auto;
			display: block;
			margin-bottom: 1rem;
		}
	}
</style>